import { sha256 } from "sha.js";
import { ICintorinConfig } from "./common/interfaces";
import { Modal } from "bootstrap";
import { openModal, dismissModal } from "./common/utilities";
import { loadOwnershipForm } from "./kronika";
import { CHRONICLE_TAB_NO } from "./common/constants";

declare const CintorinConfig: ICintorinConfig;
declare var CintorinKarta: {
    updateGraveCard:(hId: number | "none", cId: number, selectedTabIndex?: number, zId?: number) => Promise<void>
    updateCemeteryData:(cid?: number) => void
};

declare var CintorinMapa: {
    selectGrave:(locationId: string, cintorinId:number) => void
};

interface IRegistrationData {
    reg_nick: string,
    com_email: string,
    pass: string,
    passCheck: string,
    reg_suhlas: boolean,
    captchaResponse: string
}

interface ILoginData {
    login: string,
    pass: string
}

interface ILoginResult {
    isLoggedIn: boolean,
    userInactive?: boolean,
    userId?: string,
    token?: string
}

export const USER_CONTEXT_CHANGED_EVENT = "usercontextchanged";

const STORAGE_LABELS = {
    uid: "uid",
    token: "token",
}

var captchaInstance:number = -1;

document.addEventListener("readystatechange", () => {
    if (document.readyState !== 'complete') 
        return;
    let passwHandler = validatePasswordFields("passw1", "passw2", "registerNewUserForm", "registerUserButton");
    document.getElementById("passw1").addEventListener("input", passwHandler);
    document.getElementById("passw2").addEventListener("input", passwHandler);
    document.getElementById("reg_nick").addEventListener("input", validateUsernameField);
    document.getElementById("com_email").addEventListener("input", handleRegistrationFormInput);
    document.getElementById("reg_suhlas").addEventListener("input", handleRegistrationFormInput);
    document.getElementById("loginEmail").addEventListener("input", handleLoginFormInput);
    document.getElementById("loginPassword").addEventListener("input", handleLoginFormInput);
    document.getElementById("resetPwdEmail").addEventListener("input", handleResetPasswordInput);

    document.getElementById("loginLink").addEventListener("click", function () { openModal("#loginModal");});
    document.getElementById("loginLinkMobile").addEventListener("click", function () { openModal("#loginModal");});
    document.getElementById("resetPasswordLink").addEventListener("click", function () {
        dismissModal("#loginModal");
        openModal("#resetPasswordModal");
    });
    document.getElementById("registerLink").addEventListener("click", function () { openModal("#registerModal");});
    document.getElementById("registerLinkMobile").addEventListener("click", function () { openModal("#registerModal");});
    document.getElementById("registerModalLink").addEventListener("click", () => {
        dismissModal("#loginModal");
        openModal("#registerModal");
    });
    document.querySelector("#loginModal .btn-close").addEventListener("click", function () { dismissModal("#loginModal"); });
    document.querySelector("#registerModal .btn-close").addEventListener("click", function () { dismissModal("#registerModal"); });
    document.getElementById("registerDismissButton").addEventListener("click", function () { dismissModal("#registerModal"); });
    document.querySelector("#resetPasswordModal .btn-close").addEventListener("click", function () { dismissModal("#resetPasswordModal"); });

    document.getElementById("registerUserButton").addEventListener("click", handleRegisterButtonClick);
    document.getElementById("logInButton").addEventListener("click", handleLoginButtonClick);
    document.getElementById("resetPasswordButton").addEventListener("click", handleResetPasswordButtonClick);
    document.getElementById("logoutLink").addEventListener("click", logout);
    document.getElementById("logoutLinkMobile").addEventListener("click", logout);
    
    document.getElementById("loginModal").addEventListener("show.bs.modal", handleLoginModalShown);
    document.getElementById("registerModal").addEventListener("show.bs.modal", handleRegisterModalShown);
    document.getElementById("resetPasswordModal").addEventListener("show.bs.modal", handleResetPasswordModalShown);

    document.getElementById("profileLink").addEventListener("click", handleProfileLinkClicked);
    document.getElementById("profileLinkMobile").addEventListener("click", handleProfileLinkClicked);
    document.querySelector("#profileModal .btn-close").addEventListener("click", function () { dismissModal("#profileModal"); });

    document.addEventListener(USER_CONTEXT_CHANGED_EVENT, (event:CustomEvent) => { handleUserContextChanged(event.detail);});
    document.dispatchEvent(new CustomEvent(USER_CONTEXT_CHANGED_EVENT, { detail: isLoggedIn() }));
});

export function isLoggedIn() {
    return (localStorage.getItem(STORAGE_LABELS.token) !== null);
}

export function toggleAuthorizedElementsVisibility(baseSelector:string) {
    document.querySelectorAll(baseSelector+" .needs-authorization").forEach((e) => { 
        if (isLoggedIn()) {
            e.classList.remove("not-authorized");
        } else {
            e.classList.add("not-authorized");
        }
    });
}

export function addAuthorization(headers: Headers) {
    if (localStorage.getItem(STORAGE_LABELS.uid) !== null) {
        headers.append("Authorization", "Bearer "+getEncodedToken());
    }
    return headers;
}

export function captchaLoaded() {
    captchaInstance = grecaptcha.render("registrationCaptcha", {
        sitekey: CintorinConfig.recaptchaKey,
        callback: handleCaptchaSolved
    })
}

function getEncodedToken() {
    let message = CintorinConfig.siteId+localStorage.getItem(STORAGE_LABELS.uid)+localStorage.getItem(STORAGE_LABELS.token);
    let token = new sha256().update(message, "utf-8").digest("hex");
    token = localStorage.getItem(STORAGE_LABELS.uid)+":"+token;
    return window.btoa(token);
}

function handleUserContextChanged(isLoggedIn: boolean) {
    document.getElementById("loginLinkContainer").style.display = (isLoggedIn ? "none" : "");
    document.getElementById("loginLinkContainerMobile").style.display = (isLoggedIn ? "none" : "");
    document.getElementById("logoutLinkContainer").style.display = (isLoggedIn ? "" : "none");
    document.getElementById("logoutLinkContainerMobile").style.display = (isLoggedIn ? "" : "none");
    document.getElementById("profileName").innerText = localStorage.getItem(STORAGE_LABELS.uid);
    document.getElementById("profileNameMobile").innerText = localStorage.getItem(STORAGE_LABELS.uid);
    toggleAuthorizedElementsVisibility("");
    if (document.getElementById("cardHId")) {
        loadOwnershipForm();
    }
}

function handleResetPasswordInput() {
    document.getElementById("resetPasswordSuccess").style.display = "none";
    document.getElementById("resetPasswordError").style.display = "none";
    let form = document.getElementById("resetPasswordForm") as HTMLFormElement;
    (document.getElementById("resetPasswordButton") as HTMLButtonElement).disabled = !form.checkValidity();
    form.classList.add("was-validated");
}

function handleResetPasswordButtonClick() {
    let form = document.getElementById("resetPasswordForm") as HTMLFormElement;
    form.classList.remove("was-validated");
    if (form.checkValidity()) {
        let emailInput = document.getElementById("resetPwdEmail") as HTMLInputElement;
        fetch(CintorinConfig.baseUrl+"/api/users/requestPasswordReset.php",  {
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({email: emailInput.value})
        }).then(response => {
            if (response.ok && response.status == 200) {
                return true;
            } else {
                return false;
            }
        }).then(success => {
            if (success) {
                document.getElementById("resetPasswordSuccess").style.display = "";
                document.getElementById("resetPasswordError").style.display = "none";
            } else {
                document.getElementById("resetPasswordSuccess").style.display = "none";
                document.getElementById("resetPasswordError").style.display = "";
            }
        })
    } else {
        form.classList.add("was-validated");
    }
}

function handleResetPasswordModalShown() {
    (document.getElementById("resetPwdEmail") as HTMLInputElement).value = "";
    document.getElementById("resetPasswordSuccess").style.display = "none";
    document.getElementById("resetPasswordError").style.display = "none";
    document.getElementById("resetPasswordForm").classList.remove("was-validated");
}

function handleRegisterModalShown() {
    (document.getElementById("registerNewUserForm") as HTMLFormElement).reset();
    (document.getElementById("registerUserButton") as HTMLButtonElement).disabled = true;
    document.getElementById("registerNewUserForm").classList.remove("was-validated");
    document.getElementById("registerModal").removeAttribute("data-form-state");
    (document.getElementById("registrationCaptchaError") as HTMLDivElement).style.display = "";
    if (captchaInstance != -1) {
        grecaptcha.reset(captchaInstance);
        (document.getElementById("isCaptchaSolved") as HTMLInputElement).setCustomValidity("error");
    }
}

function handleLoginModalShown() {
    (document.getElementById("logInForm") as HTMLFormElement).reset();
    document.getElementById("loginModal").removeAttribute("data-form-state");
}

function handleRegistrationFormInput() {
    validateForm("registerNewUserForm", "registerUserButton");
}

function handleCaptchaSolved(response: string) {
    (document.getElementById("isCaptchaSolved") as HTMLInputElement).setCustomValidity((response != "") ? "" : "error");
    validateForm("registerNewUserForm", "registerUserButton");
}

async function handleRegisterButtonClick() {
    this.disabled = true;
    (document.getElementById("registrationCaptchaError") as HTMLDivElement).style.display = "";
    let registerForm = document.getElementById("registerNewUserForm") as HTMLFormElement;
    let isFormValid = registerForm.checkValidity();
    registerForm.classList.add("was-validated");
    if (isFormValid) {
        let response = await register(); //todo: gui zmeny, error
        switch (response) {
            case "OK":
                document.getElementById("registerModal").setAttribute("data-form-state", "registered");
                break;
            case "alreadyExists":
                document.getElementById("registerModal").setAttribute("data-form-state", "userAlreadyExists");
                break;
            case "mailError":
                document.getElementById("registerModal").setAttribute("data-form-state", "registrationMailError");
                break;
            case "captchaMissing":
            case "invalidCaptcha":
                if (captchaInstance) {
                    grecaptcha.reset(captchaInstance);
                }
                (document.getElementById("registrationCaptchaError") as HTMLDivElement).style.display = "block";
                (document.getElementById("isCaptchaSolved") as HTMLInputElement).setCustomValidity("error");
                validateForm("registerNewUserForm", "registerUserButton");
                break;
            default:
                document.getElementById("registerModal").setAttribute("data-form-state", "registrationFailed");
                break;
        }
    }
}

function handleLoginFormInput() {
    let emailInput = document.getElementById("loginEmail") as HTMLInputElement;
    (document.getElementById("loginPassword") as HTMLInputElement).setCustomValidity("");
    if (emailInput.value?.trim() == "") {
        emailInput.setCustomValidity("error");
    } else {
        emailInput.setCustomValidity("");
    }
    validateForm("logInForm", "logInButton");
}

function handleLoginButtonClick() {
    let request:ILoginData = {
        login: (document.getElementById("loginEmail") as HTMLInputElement).value?.trim(),
        pass: (document.getElementById("loginPassword") as HTMLInputElement).value
    };
    if (request.login) {
        fetch(CintorinConfig.baseUrl+"/api/users/login.php",  {
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(request)
        }).then(response => {
            if (response.ok && response.status == 200) {
                return response.json();
            }
        }).then(loginResponse => {
            let result = (loginResponse as ILoginResult);
            if (result && result.isLoggedIn) {
                localStorage.setItem(STORAGE_LABELS.token, result.token);
                localStorage.setItem(STORAGE_LABELS.uid, result.userId);
                document.dispatchEvent(new CustomEvent(USER_CONTEXT_CHANGED_EVENT, { detail: true }));
                (document.getElementById("logInForm") as HTMLFormElement).classList.remove("was-validated");
                (document.getElementById("loginEmail") as HTMLInputElement).value = "";
                (document.getElementById("loginPassword") as HTMLInputElement).value = "";
                Modal.getOrCreateInstance("#loginModal").hide();
            } else if (result && result.userInactive) {
                localStorage.removeItem(STORAGE_LABELS.token);
                localStorage.removeItem(STORAGE_LABELS.uid);
                document.dispatchEvent(new CustomEvent(USER_CONTEXT_CHANGED_EVENT, { detail: false }));
                document.getElementById("loginModal").setAttribute("data-form-state", "userInactive");
            } else {
                // logout
                localStorage.removeItem(STORAGE_LABELS.token);
                localStorage.removeItem(STORAGE_LABELS.uid);
                document.dispatchEvent(new CustomEvent(USER_CONTEXT_CHANGED_EVENT, { detail: false }));
                (document.getElementById("loginPassword") as HTMLInputElement).setCustomValidity("error");
                validateForm("logInForm", "logInButton");
            }
        });
    }
}

function handleProfileLinkClicked() {
    if (isLoggedIn()) {
        fetch(CintorinConfig.baseUrl+"/api/users/htmlGetProfileContent.php", {
            method: "GET",
            headers: addAuthorization(new Headers())
        }).then(response => {
            if (response.ok && response.status == 200) {
                return response.text();
            }
        }).then(htmlText => {
            (document.querySelector("#profileModal h5") as HTMLHeadingElement).innerText = localStorage.getItem(STORAGE_LABELS.uid);
            document.querySelector("#profileModal .modal-body").innerHTML = htmlText;
            let emailIsVerified = (document.getElementById("emailVerified") as HTMLInputElement).value;
            document.getElementById("emailNotVerifiedSpan").style.display = (emailIsVerified == "1") ? "none" : "";
            document.getElementById("profile_nick")?.addEventListener("input", handleNickInputChanged);
            document.getElementById("changeNickButton")?.addEventListener("click", handleChangeNickClicked);
            let passwordValidation = validatePasswordFields("profilePassw1", "profilePassw2", "changePasswordForm", "changePasswordButton");
            let passwordInputHandler = function () {
                hideErrorMessages("changePassword");
                passwordValidation();
                if ((document.getElementById("profilePassw1") as HTMLInputElement).value == "") {
                    document.getElementById("changePasswordForm").classList.remove("was-validated");
                }
            }
            document.getElementById("profilePassw1")?.addEventListener("input", passwordInputHandler);
            document.getElementById("profilePassw2")?.addEventListener("input", passwordInputHandler);
            document.getElementById("changePasswordButton")?.addEventListener("click", changePassword);
            document.querySelectorAll("#graveAdminList .fake-link").forEach(e => e.addEventListener("click", handleGraveShortcutClicked));
            openModal("#profileModal");
        });
    }
}

function handleNickInputChanged() {
    hideErrorMessages("changeNick");
    if (this.value != this.defaultValue) {
        this.setCustomValidity((this.value != "") ? "" : "error");
        validateForm("userNickForm", "changeNickButton");
    } else {
        document.getElementById("userNickForm").classList.remove("was-validated");
        (document.getElementById("changeNickButton") as HTMLButtonElement).disabled = true;
    }
}

function handleChangeNickClicked() {
    (document.getElementById("changeNickButton") as HTMLButtonElement).disabled = true;
    let newNick = (document.getElementById("profile_nick") as HTMLInputElement).value.trim();
    if (newNick != "") {
        fetch(CintorinConfig.baseUrl+"/api/users/changeUser.php", {
            method: "POST",
            headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
            body: JSON.stringify({
                usernick: newNick
            })
        }).then(response => {
            let success = (response.ok && response.status == 200);
            (document.getElementById("changeNickButton") as HTMLButtonElement).disabled = !(document.getElementById("userNickForm") as HTMLFormElement).checkValidity();
            document.getElementById("changeNickError").style.display = success ? "none" : "";
            document.getElementById("changeNickSuccess").style.display = success ? "" : "none";
            document.getElementById("userNickForm").classList.remove("was-validated");
            if (success) {
                let input = document.getElementById("profile_nick") as HTMLInputElement;
                input.defaultValue = input.value;
            }
        });
    }
}

function handleGraveShortcutClicked() {
    let graveId = +this.getAttribute("data-grave-id");
    if (graveId) {
        let cId = Math.floor(graveId / 1000000);
        CintorinKarta.updateCemeteryData(cId);
        CintorinKarta.updateGraveCard(graveId, cId, CHRONICLE_TAB_NO).then(function () {
            if (document.getElementById("cardIdentifier")){
                CintorinMapa.selectGrave((document.getElementById("cardIdentifier") as HTMLInputElement).value, cId);
            }
        });
        dismissModal("#profileModal");
    }
}

function hideErrorMessages(prefix: string) {
    document.getElementById(prefix+"Error").style.display = "none";
    document.getElementById(prefix+"Success").style.display = "none";
}

function changePassword() {
    let passw1 = (document.getElementById("profilePassw1") as HTMLInputElement).value.trim();
    let passw2 = (document.getElementById("profilePassw2") as HTMLInputElement).value.trim();
    fetch(CintorinConfig.baseUrl+"/api/users/changePassword.php", {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify({
            passw1: passw1,
            passw2: passw2
        })
    }).then(response => {
        if (response.ok && response.status == 200) {
            (document.getElementById("profilePassw1") as HTMLInputElement).value = "";
            (document.getElementById("profilePassw2") as HTMLInputElement).value = "";
            document.getElementById("changePasswordError").style.display = "none";
            document.getElementById("changePasswordSuccess").style.display = "";
            (document.getElementById("changePasswordButton") as HTMLButtonElement).disabled = true;
        } else {
            document.getElementById("changePasswordError").style.display = "";
            document.getElementById("changePasswordSuccess").style.display = "none";
        }
        document.getElementById("changePasswordForm").classList.remove("was-validated");
    });
}

function logout() {
    return fetch(CintorinConfig.baseUrl+"/api/users/logout.php",  { //todo: spravit token zavislym na case loginu (expiracia)?
        method: "GET",
        headers: addAuthorization(new Headers({}))
    }).then(response => {
        localStorage.removeItem(STORAGE_LABELS.token);
        localStorage.removeItem(STORAGE_LABELS.uid);
        document.dispatchEvent(new CustomEvent("usercontextchanged", { detail: false }));
    });
}

async function register() :Promise<string> {
    return fetch(CintorinConfig.baseUrl+"/api/users/registerUser.php",  {
        method: "PUT",
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(getRegistrationData())
    }).then(response => {
        if (response.ok && response.status == 201) {
            return response.text();
        } else if (response.status == 400) {
            return response.text();
        } else if (response.status == 409) {
            return "alreadyExists";
        } else {
            return "error";
        }
    });
}

function getRegistrationData() :IRegistrationData {
    return {
        reg_nick: (document.getElementById("reg_nick") as HTMLInputElement).value,
        com_email: (document.getElementById("com_email") as HTMLInputElement).value,
        pass: (document.getElementById("passw1") as HTMLInputElement).value,
        passCheck: (document.getElementById("passw2") as HTMLInputElement).value,
        reg_suhlas: (document.getElementById("reg_suhlas") as HTMLInputElement).checked,
        captchaResponse: grecaptcha.getResponse(captchaInstance)
    };
}

function validatePasswordFields(pass1Id:string, pass2Id:string, formId:string, submitButtonId: string) {
    return function () {
        let mainPassword = document.getElementById(pass1Id) as HTMLInputElement;
        let checkPassword = document.getElementById(pass2Id) as HTMLInputElement;
        if (checkPassword.value !== mainPassword.value) {
            checkPassword.setCustomValidity("error");
        } else {
            checkPassword.setCustomValidity("");
        }
        validateForm(formId, submitButtonId);
    }
}

function validateUsernameField() {
    let field = document.getElementById("reg_nick") as HTMLInputElement;
    if (field.value && field.value.trim() != "") { 
        field.setCustomValidity("");
    } else {
        field.setCustomValidity("error");
    }
    validateForm("registerNewUserForm", "registerUserButton");
}

function validateForm(formId:string, submitButtonId: string) {
    let form = document.getElementById(formId) as HTMLFormElement;
    let submitButton = document.getElementById(submitButtonId) as HTMLButtonElement;
    if (form.checkValidity()) {
        submitButton.disabled = false;
    } else {
        submitButton.disabled = true;
    }
    form.classList.add("was-validated");
}